export * from './componetTypes';
export * from './redux';

export type FormStateType = 'form' | 'confirm' | 'success';

export interface IAutontificationComponent {
  onChange: (n: FormStateType) => void;
  email?: string;
  setEmail?: (n: string) => void;
}

export interface FileObjectType extends File {
  preview: string;
  id: number;
  path?: string;
}

export enum OnlyStatusType {
  New = 'New',
  Pending = 'Pending',
  Closed = 'Closed',
  InProgress = 'in_progress',
  Decline = 'decline',
}

export interface IChallenge {
  expires_at: string;
  required_sales: number;
  sales_count: number;
  start_at: string;
  temp_balance: string;
  status: string;
}
